const strings = {
	alertCount: "Alert Count",
	alertLastTime: "Last Alert",
	alertStartTime: "Alert Start Time",
	alertStatus: "Alert Status",
	binderDescription: "Binder Description",
	binderLink: "Binder Link",
	binderName: "Binder Name",
	binderOwner: "Binder Owner",
	bookmarked: "Bookmarked",
	clientCode: "Client Code",
	dateCreated: "Date Created",
	dateEdited: "Date Edited",
	dateShared: "Date Shared",
	lastViewed: "Last Viewed",
	sharedWith: "Shared With",
	tabCount: "Tabs",
};

export const ALERT_RATE = {
	name: "alertRate",
	label: strings.alertStatus,
	sort: 25,
	default: true,
};
export const ALERT_COUNT = {
	name: "alertCount",
	label: strings.alertCount,
	sort: 26,
	default: false,
};
export const ALERT_START = {
	name: "alertStartTime",
	label: strings.alertStartTime,
	sort: 27,
	default: false,
	minWidth: 128,
};
export const BOOKMARK = {
	name: "bookmarked",
	label: strings.bookmarked,
	sort: 45,
	default: true,
};
export const CLIENT_CODE = {
	name: "clientCode",
	label: strings.clientCode,
	sort: 35,
	default: true,
};
export const CREATE_TIME = {
	name: "createTime",
	label: strings.dateCreated,
	sort: 20,
	default: true,
	minWidth: 104,
};
export const EDIT_TIME = {
	name: "updateTime",
	label: strings.dateEdited,
	sort: 21,
	default: false,
};
export const SHARE_TIME = {
	name: "shareTime",
	label: strings.dateShared,
	sort: 22,
	default: false,
};
export const LINK = {
	name: "link",
	label: strings.binderLink,
	sort: 40,
	default: true,
};
export const TAB_COUNT = {
	name: "tabCount",
	label: strings.tabCount,
	sort: 41,
	default: false,
};
export const OBSERVERS = {
	name: "observers",
	label: strings.sharedWith,
	sort: 30,
	default: true,
	minWidth: 104,
};
export const OWNER_NAME = {
	name: "ownerName",
	label: strings.binderOwner,
	sort: 10,
	default: true,
	minWidth: 104,
};
export const SELECT = { name: "select", label: "", sort: 1, default: true, minWidth: 40 };
export const TITLE = {
	name: "title",
	label: strings.binderName,
	sort: 5,
	default: true,
	minWidth: 104,
};
export const DESCRIPTION = {
	name: "description",
	label: strings.binderDescription,
	sort: 6,
	default: false,
	minWidth: 128,
};
export const VIEW_TIME = {
	name: "viewTime",
	label: strings.lastViewed,
	sort: 15,
	default: true,
};
export const ALERT_LAST = {
	name: "alertLastTime",
	label: strings.alertLastTime,
	sort: 16,
	default: false,
};
